import { render, staticRenderFns } from "./AddExamResult.vue?vue&type=template&id=3757ea6a&"
import script from "./AddExamResult.vue?vue&type=script&lang=js&"
export * from "./AddExamResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports